/* global dataLayer */

import { Controller } from 'stimulus';

class OrderForm extends Controller {
  onSubmit(event) {
    const id = event.currentTarget.getAttribute('data-variant-id');
    const price = event.currentTarget.getAttribute('data-price');

    this.sendToGTM(id, price);
  }

  // eslint-disable-next-line
  sendToGTM(id, price) {
    dataLayer.push({
      event: 'add_to_cart',
      conversion_value: price || 0,
      product_id: id,
    });
  }
}

OrderForm.targets = [
  //
];

export default OrderForm;
